module.exports = __webpack_public_path__ + "static/our-difference-931da37bcab7c3736fd7670303fa6840.svg";